import { ThemeColor } from '@/enums'
import { Checked } from '@/icons'
import { Spinner, Typography } from '../../atoms'
import { WithTimeoutRendering } from '../../hoc'
import { Column } from '../../styled'
import { IconWrapper, Step } from './styles'
import { useEffect } from 'react'

interface Props {
  steps: string[]
  totalDelay?: number
  onComplete?: () => void
}

export const ProgressiveLoader = ({
  steps = [],
  totalDelay = 2500,
  onComplete,
}: Props) => {
  const delayPerStep = totalDelay / steps.length

  useEffect(() => {
    const timeout = setTimeout(() => {
      onComplete?.()
    }, totalDelay)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Column>
      {steps?.map((item, i) => (
        <Step key={`step-${i}`}>
          <Typography color={ThemeColor.b50} variant="captionB">
            {item}
          </Typography>
          <IconWrapper>
            <WithTimeoutRendering delay={delayPerStep * i}>
              <WithTimeoutRendering
                delay={delayPerStep}
                renderIfNotComplete={<Spinner />}
              >
                <Checked fill="transparent" size="button" />
              </WithTimeoutRendering>
            </WithTimeoutRendering>
          </IconWrapper>
        </Step>
      ))}
    </Column>
  )
}
